import EmptyMessageIcon from "@assets/icons/message-empty.svg";
import { useI18n } from "@core/i18n/i18n";
import styled from "@emotion/styled";
import { MessageContainer } from "@ui/components/common/message-container";
import { colors } from "@ui/style/colors";
import React from "react";

export const EmptyNotificationList = (): JSX.Element => {
	const { format } = useI18n();
	return (
		<>
			<Line />
			<Container>
				<MessageContainer
					iconSvg={EmptyMessageIcon}
					title={format("notificationCenter.emptyList.title")}
					description={format("notificationCenter.emptyList.subtitle")}
				/>
			</Container>
		</>
	);
};

const Container = styled.div`
	margin-top: 128px;
	margin-bottom: 128px;
	display: grid;
	place-content: center;
`;

const Line = styled.div`
	margin-top: 16px;
	height: 1px;
	background-color: ${colors.grey10};
`;
